import { render, staticRenderFns } from "./Parameterization.vue?vue&type=template&id=61d6e4de&scoped=true&"
import script from "./Parameterization.vue?vue&type=script&lang=js&"
export * from "./Parameterization.vue?vue&type=script&lang=js&"
import style0 from "./Parameterization.vue?vue&type=style&index=0&id=61d6e4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6e4de",
  null
  
)

export default component.exports